var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{opacity:0.5;}\n\t.st3{fill:#DEEACE;}\n\t.st4{fill:#71C6D8;}\n\t.st5{fill:none;stroke:#71C6D8;stroke-width:0.05;stroke-miterlimit:10;}\n\t.st6{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st7{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st9{fill:#1E1E1C;}\n\t.st10{fill:#020203;}\n\t.st11{fill:#B2115B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0,0v32h32V0H0z M30,30H2V2h28V30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.8,6.2v19.6H2.2V6.2H29.8 M30,6H2v20h28V6L30,6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M21.8,10.21v11.6H10.2v-11.6H21.8 M22,10.01H10v12h12V10.01L22,10.01z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.8,4.2v23.6H4.2V4.2H27.8 M28,4H4v24h24V4L28,4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M25.8,2.2v27.6H6.2V2.2H25.8 M26,2H6v28h20V2L26,2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16,2.2c7.61,0,13.8,6.19,13.8,13.8S23.61,29.8,16,29.8S2.2,23.61,2.2,16S8.39,2.2,16,2.2 M16,2 C8.27,2,2,8.27,2,16c0,7.73,6.27,14,14,14s14-6.27,14-14C30,8.27,23.73,2,16,2L16,2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.8,0.2v31.6H0.2V0.2H31.8 M32,0H0v32h32V0L32,0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 16,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 20.29,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 25.24,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 32,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 32,
    y2: 6.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 32,
    y2: 11.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 32,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 32,
    y2: 20.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 32,
    y2: 25.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 32,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 25.24,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 20.29,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 16,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 11.71,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 6.76,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 32,
    x2: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 25.24,
    x2: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 20.29,
    x2: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 16,
    x2: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 11.71,
    x2: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 0,
    y2: 6.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 0,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 6.76,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 16,
    y1: 16,
    x2: 11.71,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 16,
    cy: 16,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 16,
    cy: 16,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 16,
    cy: 16,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 16,
    cy: 16,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 16,
    cy: 16,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 16,
    cy: 16,
    r: 2
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "earlier",
    className: "st0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "25.71,11.3 24.29,12.71 26.58,15 15,15 15,17 26.59,17 24.29,19.3 25.71,20.71 30.41,16.01  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,28C9.38,28,4,22.62,4,16S9.38,4,16,4c2.66,0,5.2,0.87,7.32,2.52l1.23-1.58C22.07,3.02,19.11,2,16,2 C8.28,2,2,8.28,2,16s6.28,14,14,14c3.11,0,6.07-1.02,8.55-2.94l-1.23-1.58C21.2,27.13,18.66,28,16,28z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.7c6595850f364e735bd8b71436576cc1.svg";
export { ForwardRef as ReactComponent };